import { useVersionUpdate } from '@/hooks/use-version-update'

/**
 * Headless component that wires the deploy-detection hook into the React tree.
 * Renders nothing; the hook drives a Sonner toast when a new build is available.
 */
export function VersionUpdateChecker(): null {
  useVersionUpdate()
  return null
}
